import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import * as S from './Home.styled';

const DriverHome = () => {
	const isMobileLandscape = useMediaQuery(Breakpoints.isMobileLandscape);

	return (
		<S.Container>
			<S.CardsSection className="driver-home">
				<S.CardsSection className="black-background">
					<Image
						url={'https://storage.googleapis.com/tryoto-public/screenshots/otoflex-driver.png'}
						height={isMobileLandscape ? '20rem' : '26rem'}
						width={isMobileLandscape ? '20rem' : '26rem'}
					/>
					<Typography
						variant="h2"
						fontWeight="800"
						className="my-4 text-center"
						color="white"
						noWrap
						style={{ overflow: 'unset' }}>
						downloadApp
					</Typography>
					<Typography
						variant="p1"
						fontWeight="500"
						color="white"
						noWrap
						className="text-center"
						style={{ overflow: 'unset' }}>
						driverHomeText1
					</Typography>
					<Typography
						variant="p1"
						fontWeight="500"
						className="my-5 text-center"
						color="white"
						noWrap
						style={{ overflow: 'unset' }}>
						driverHomeText2
					</Typography>

					<Image
						url={'https://storage.googleapis.com/tryoto-public/public/assets/images/otoflex-qr.svg'}
						height="16rem"
						width="16rem"
					/>

					<S.RowDriver className="mt-5">
						<Button
							component="a"
							href="https://play.google.com/store/apps/details?id=com.tryoto.otodriverapp"
							target="_blank"
							variant="transparent">
							<Image
								url={'https://storage.googleapis.com/tryoto-public/screenshots/playstore.svg'}
								width="16rem"
								height="8rem"
							/>
						</Button>
						<Button
							component="a"
							href="https://apps.apple.com/us/app/oto-driver/id1535770290"
							target="_blank"
							variant="transparent">
							<Image
								url={'https://storage.googleapis.com/tryoto-public/screenshots/appstore.svg'}
								width="16rem"
								height="8rem"
							/>
						</Button>
					</S.RowDriver>
				</S.CardsSection>
			</S.CardsSection>
		</S.Container>
	);
};

export default DriverHome;
